import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SecurityService } from '../../services/security.service';
import { SecurityUser } from '../../beans/SecurityUser';
import { StorageService } from '../../services/storage.service';

@Component({
	selector: 'app-security-users',
	templateUrl: './security-users.component.html',
	styleUrls: ['./security-users.component.scss']
})
export class SecurityUsersComponent implements OnInit {

	users: SecurityUser[] = [];
	message: string = '';

	// за формата за регистрация
	newUser = {
		username: '',
		password: '',
		names: '',
		email: '',
		phone: '',
		role: 'ROLE_USER'
	};

	constructor(
		private securityService: SecurityService,
		private storageService: StorageService,
		private router: Router
	) { }

	ngOnInit() {
		this.loadUsers();
	}

	loadUsers() {
		this.securityService.listUsers().subscribe(res => {
			this.users = res.sort((a, b) =>
				(a.names || '').localeCompare(b.names || '', 'bg')
			);
		});
	}

	register() {
		this.securityService.registerUser(
			this.newUser.username,
			this.newUser.password,
			this.newUser.names,
			this.newUser.email,
			this.newUser.phone,
			this.newUser.role
		).subscribe(_ => {
			this.message = 'Потребител създаден успешно!';
			this.loadUsers();
		}, err => this.message = err.error.message || 'Грешка');
	}

	changePassword(u: any) {
		const pass = window.prompt('Нова парола за ' + u.username);
		if (!pass) return;

		this.securityService.changePassword(u.username, pass)
			.subscribe({
				next: _ => {
					this.message = 'Паролата е сменена успешно.';
					this.loadUsers();
				},
				error: err => {
					// backend message e .message или .error.message
					let backendMessage = err.error.message;
					this.message = "❌ " + backendMessage;
					console.error('changePassword error:', err);
				}
			});
	}

	changeRole(u: any) {
		const newRole = (u.authority === 'ROLE_ADMIN' ? 'ROLE_USER' : 'ROLE_ADMIN');

		this.securityService.changeUserAuthority(u.username, newRole)
			.subscribe(_ => {
				this.message = 'Ролята е сменена';
				this.loadUsers();  // 🔥 презарежда данните от backend
			});
	}

	changeBulins(u: SecurityUser) {
		let newValue = !u.bulinsAuthority;

		this.securityService.changeUserBulinsAuthority(u.username, newValue).subscribe(_ => {
			this.message = 'Bulins правата обновени';
			this.loadUsers();
		});
	}

	unlock(u: any) {
		this.securityService.unlockUser(u.username)
			.subscribe(_ => {
				this.message = 'Потребителят е отключен';
				this.loadUsers(); // 🔥 Презарежда новото locked състояние
			});
	}

	activate(u: SecurityUser) {
		let newValue = !u.enabled;

		this.securityService.activateUser(u.username, newValue).subscribe(_ => {
			this.message = 'Акаунтът е активиран/деактивиран';
			this.loadUsers();
		});
	}
	refresh() {
		this.message = "";
		this.loadUsers();
	}

	changeNdo(u: any) {
		const newVal = !u.isNDO;

		this.securityService.changeUserNdo(u.username, newVal)
			.subscribe(_ => {
				this.message = 'NDO сменено';
				this.loadUsers(); // 🔥 обновява UI
			});
	}
	
	changeColor(u: SecurityUser, color: string) {
		this.securityService.changeColor(u.username, color).subscribe(_ => {
			this.message = 'Цветът е обновен';
			this.loadUsers();
		});
	}

	changeEmailVerified(u: SecurityUser) {
		const newValue = !u.emailVerified;
		this.securityService.changeEmailVerified(u.username, newValue).subscribe(_ => {
			this.message = 'Email verified обновено';
			this.loadUsers();
		});
	}

	impersonate(u: SecurityUser) {
		if (!confirm('Влизане като ' + u.username + '?')) return;

		this.securityService.impersonate(u.username).subscribe({
			next: (loginResponse) => {
				this.storageService.setLoginResponse(loginResponse);
				this.storageService.removePasswordMessage();
				this.router.navigateByUrl('/cases');
			},
			error: err => {
				this.message = '❌ ' + (err.error.message || 'Грешка при impersonation');
			}
		});
	}

	editField(u: any, field: string) {
	const current = u[field] || '';
	const label = field === 'names' ? 'Имена' :
		          field === 'email' ? 'Email' : 'Телефон';

	const newValue = window.prompt('Нова стойност за ' + label + ':', current);

	// Ако cancel → нищо не правим
	if (newValue === null) return;

	this.securityService.updateUserFields(
		u.username,
		field === 'names' ? newValue : undefined,
		field === 'email' ? newValue : undefined,
		field === 'phone' ? newValue : undefined
	).subscribe({
		next: _ => {
			this.message = label + ' обновени успешно!';
			this.loadUsers(); // 🔥 обновяване
		},
		error: err => {
			let msg = err.error.message;
			this.message = '❌ ' + msg;
			console.error(err);
		}
	});
}


}
